import { render, staticRenderFns } from "./_SupplierTabs.vue?vue&type=template&id=468f15a2"
import script from "./_SupplierTabs.vue?vue&type=script&lang=js"
export * from "./_SupplierTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports